import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FormSection } from "components/FormControls/FormSection";
import { HelpPanel } from "components/HelpPanel/HelpPanel";
import { FormikErrors } from "formik";
import { useMessage } from "hooks/intl";
import { DefaultLanguageDataState } from "reduxState/translations/translationsSlice";
import { CampaignFEValues, CampaignTriggers } from "types/campaigns";
import { CampaignStepsIds, CampaignStepsUnion } from "../CampaignForm";
import { TriggerBox } from "../Triggers/TriggerBox";
import { BasicInfo } from "./Sections/BasicInfo";
import { Rules } from "./Sections/Rules";
import { TransactionFilters } from "./Sections/TransactionFilters";
import { SectionWrapper } from "./SectionWrapper";
import { useStyles } from "./styles";

interface Props {
  values: CampaignFEValues;
  defaultLang: DefaultLanguageDataState;
  skipToStep: (id: CampaignStepsUnion) => void;
  errors: FormikErrors<CampaignFEValues>;
}

export const Summary = ({ values, defaultLang, skipToStep, errors }: Props) => {
  const classes = useStyles({});
  const { message } = useMessage();
  const { translations, active, activity, visibility, displayOrder, trigger } =
    values;

  const showTransactionFilters = !!(
    trigger === CampaignTriggers.TRANSACTION ||
    trigger === CampaignTriggers.RETURN_TRANSACTION
  );

  const areTransactionFilters = !!(
    "transactionItemsFilters" in values &&
    values.transactionItemsFilters &&
    values.transactionItemsFilters?.length > 0
  );
  const areRules = !!(values.rules && values.rules.length > 0);

  return (
    <Grid container spacing={12}>
      <Grid size={{ xs: 8 }}>
        <Typography mb={8}>
          <div className={classes.sectionTitleWrapper}>
            {message({ id: "summary" })} <TriggerBox />
          </div>
        </Typography>
        <FormSection>
          <SectionWrapper
            title={message({ id: "basicInfoSummary" })}
            onClick={() => skipToStep(CampaignStepsIds.INFO)}
          >
            <BasicInfo
              defaultLang={defaultLang}
              translations={translations}
              active={active}
              activity={activity}
              visibility={visibility}
              displayOrder={displayOrder}
              errors={errors}
            />
          </SectionWrapper>
        </FormSection>
        {showTransactionFilters && areTransactionFilters && (
          <FormSection>
            <SectionWrapper
              title={message({ id: "transactionFiltersSummary" })}
              onClick={() => skipToStep(CampaignStepsIds.RULES)}
              noPadding
            >
              <TransactionFilters
                transactionItemsFilters={values.transactionItemsFilters}
              />
            </SectionWrapper>
          </FormSection>
        )}

        {areRules && (
          <FormSection>
            <SectionWrapper
              title={message({ id: "rulesAndEffectSummary" })}
              onClick={() => skipToStep(CampaignStepsIds.RULES)}
              noPadding
            >
              <Rules campaignData={values} errors={errors} />
            </SectionWrapper>
          </FormSection>
        )}
      </Grid>
      <Grid size={{ xs: 4 }} mt={20}>
        <HelpPanel title="summary" description="summaryHelpDesc" />
      </Grid>
    </Grid>
  );
};
